import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

import { IconButton } from '@restworld/ui-ds-base';

function BackButton({ onClick, className }: BackButtonProps) {
  const { t } = useTranslation('common');

  return <IconButton ariaLabel={t('go_back')} Icon={ArrowLeftIcon} onClick={onClick} className={className} />;
}
export default BackButton;

interface BackButtonProps {
  onClick?: () => void;
  className?: string;
}
